/* eslint-disable jsx-a11y/alt-text */
import { Link } from 'react-router';

import { useEffect, useState } from 'react';
import axios from 'axios';

import RugbyHeader from '../components/header/rugby-header';

import './rugby-results.css';





const srcpath = 'https://familyrugby.com/yt.json'

function RugbyResults() {
    const [articles, setArticles] = useState([]);

    useEffect(() => {
        axios
            .get(srcpath)
            .then(response => setArticles(response.data.rugbyresultscard))
            .catch(error => console.error("Ошибка при загрузке JSON:", error));
    }, []);
    return (
        <>
            <RugbyHeader />
            <div className="results">
                <div className='results__hero'>
                    <div className="container results-container">
                        <div className='results__hero_title'>OUR RESULTS</div>
                        {/* <div className='results__hero_subtitle'>About & Players</div> */}
                    </div>
                </div>

                <div className="container results-container">
                    <div className='results__cards'>
                        <div className='results__cards_box'>
                            {/* <div className='results__card results__uptexts'>
                                <div className='results__card-item-box resutls_gap'>
                                    <div className='results__card-item-img ourteam'>Our Team</div>
                                    <div className='score'>
                                        Score
                                    </div>
                                    <div className='results__card-item-img enemeyteam'>Opponent Team</div>
                                </div>



                                <span className='wall'></span>



                                <div className='matchinfo matchinfo__uptext'>
                                    <div className='results__card-item matchdate'>Date</div>
                                    <div className='results__card-item matchtime'>Time</div>
                                </div>



                                <div className='results__card-item matchlocation matchlocation__uptext'>Location</div>


                            </div> */}

                            {articles.map((article, index) => {
                                return (
                                    <div key={index} className='results__card'>

                                        <div className='results__date'>{article.matchdate}</div>
                                        <div className='results__location'>{article.matchlocation}</div>
                                        <div className='results__match'>
                                            <div className='our_team'><img src={article.teamlogosrc} /></div>
                                            <div className='score'>
                                                <div className='our_score'>{article.ourscore}</div>
                                                <div className='our_score'>{article.opponentscore}</div>
                                            </div>
                                            <div className='our_team'><img src={article.againstteamsrc} /></div>
                                        </div>

                                        <Link href={`/about-player-id`} className='results__players_card-link'>Full Game</Link>
                                    </div>
                                );
                            })}


                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}


export default RugbyResults;